module.exports = __webpack_public_path__ + "75e0c747aa1405f7e726c08c7f72ae79.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201509_Presse_AVANGA_SK_637KB.jpg
// module id = 561
// module chunks = 0